<section class="card">
    <div class="card-body">
        <form class="cat__app__profile__container py-0" #personalForm="ngForm">
            <section class="row">
                <div class="col-12 col-lg-6">
                    <div class="form-group py-0">
                        <div class="row">
                            <div class="col-12 mb-3">
                                <h4 class="text-black">
                                    <strong>Name</strong>
                                </h4>
                            </div>
                            <div class="col-md-4 col-xl-2">
                                <div class="d-flex flex-column mb-2 mb-md-0">
                                    <label class="form-control-label">Prefix</label>
                                    <select class="form-control"
                                            name="prefixType"
                                            required
                                            #prefixType="ngModel"
                                            [(ngModel)]="model.prefixType.prefixTypeId"
                                            id="profile-Prefix">
                                        <option class="form-check" *ngFor="let option of dictData.PrefixType" [ngValue]="option.cmgmtPrefixTypeId">
                                            {{ option.description }}
                                        </option>
                                    </select>
                                    <div class="form-control-error"
                                            *ngIf="!prefixType.valid && (prefixType.touched || state.isSubmitted)">
                                        <ul>
                                            <li *ngIf="prefixType?.errors?.required">Prefix is required.</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-8 col-xl-6">
                                <div class="d-flex flex-column form-group py-0">
                                    <label class="form-control-label" for="profile-FirstName">First Name</label>
                                    <input type="text"
                                            name="firstName"
                                            [(ngModel)]="model.firstName"
                                            class="form-control"
                                            maxlength="80"
                                            #firstName="ngModel"
                                            required
                                            id="profile-FirstName">
                                    <div class="form-control-error"
                                            *ngIf="!firstName.valid && (firstName.touched || state.isSubmitted)">
                                        <ul>
                                            <li *ngIf="firstName?.errors?.required">First Name is required.</li>
                                            <li *ngIf="firstName?.errors?.maxlength">Must be 80 characters long.</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-12 col-xl-4">
                                <div class="d-flex flex-column form-group py-0 mb-0 mb-md-3">
                                    <label class="form-control-label" for="profile-MiddleInitial">Middle Initial</label>
                                    <input type="text"
                                            name="middleInitial"
                                            [(ngModel)]="model.middleInitial"
                                            class="form-control"
                                            maxlength="1"
                                            #middleInitial="ngModel"
                                            id="profile-MiddleInitial">
                                    <div class="form-control-error"
                                            *ngIf="!middleInitial.valid && (middleInitial.touched || state.isSubmitted)">
                                        <ul>
                                            <li *ngIf="middleInitial?.errors?.maxlength">Must be 1 character long.</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-8 col-xl-8">
                                <div class="d-flex flex-column form-group py-0">
                                    <label class="form-control-label" for="profile-LastName">Last Name</label>
                                    <input type="text"
                                            name="lastName"
                                            [(ngModel)]="model.lastName"
                                            class="form-control"
                                            maxlength="60"
                                            #lastName="ngModel"
                                            required
                                            id="profile-LastName">
                                    <div class="form-control-error"
                                            *ngIf="!lastName.valid && (lastName.touched || state.isSubmitted)">
                                        <ul>
                                            <li *ngIf="lastName?.errors?.required">Last Name is required.</li>
                                            <li *ngIf="lastName?.errors?.maxlength">Must be 60 characters long.</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-4 col-xl-4">
                                <div class="d-flex flex-column">
                                    <label class="form-control-label" for="profile-Suffix">Suffix</label>
                                    <input type="text"
                                            name="suffix"
                                            maxlength="20"
                                            #suffix="ngModel"
                                            [(ngModel)]="model.suffix"
                                            class="form-control"
                                            id="profile-Suffix">
                                    <div class="form-control-error"
                                         *ngIf="!suffix.valid && (suffix.touched || state.isSubmitted)">
                                        <ul>
                                            <li *ngIf="suffix?.errors?.maxlength">Must be 20 characters long.</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12 col-sm-6 col-md-8">
                                <div class="d-flex flex-column form-group py-0 mb-0">
                                    <label class="form-control-label" for="profile-BirthDate">Date of Birth</label>
                                    <div class="input-group py-0"  (clickOutside)="d.close()">
                                        <div class="input-group-append">
                                            <input class="form-control"
                                                    placeholder="mm/dd/yyyy"
                                                    name="dp"
                                                    ngbDatepicker
                                                    [firstDayOfWeek]="7"
                                                    [minDate]="dobMinDate"
                                                    [maxDate]="dobMaxDate"
                                                    [(ngModel)]="dob"
                                                    (ngModelChange)="reverseParseDob()"
                                                    #d="ngbDatepicker"
                                                    #dobField="ngModel"
                                                    required
                                                    id="profile-BirthDate">
                                            <div class="input-group-text" (click)="toggle(d)">
                                                <img src="assets/img/calendar-icon.svg"
                                                        style="width: 1.2rem; height: 1rem; cursor: pointer;"/>
                                            </div>
                                            <div class="form-control-error"
                                                    *ngIf="!dobField.valid && (dobField.touched || state.isSubmitted)">
                                                <ul>
                                                    <li *ngIf="dobField?.errors?.required">Date of Birth is required.</li>
                                                    <li *ngIf="dobField?.errors?.ngbDate?.invalid ||
                                                                    dobField?.errors?.ngbDate?.requiredBefore ||
                                                                    dobField?.errors?.ngbDate?.requiredAfter">Invalid date format.</li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-lg-6">
                    <div class="row">
                        <div class="col-12 profile-title">
                            <h5 class="text-black pl-sm-4">
                                <strong>Profile Picture</strong>
                            </h5>
                        </div>
                        <div class="col-12 mb-4 mb-lg-0">
                            <div class="avatar-preview" style="float: right;" [style.backgroundImage]="'url(' + currentImage.imagePath + ')'">
                            </div>
                            <div class="pl-0 pl-md-4 image-info">
                                <p>Your profile picture will be shown on your member profile and your fundraising page</p>
                                <p>Ideal size is 200 x 200 and the file must be a JPG, GIF, or PNG</p>
                                <div>
                                    <button class="btn btn-primary ui-change-image"
                                            (click)="openProfilePictureChangeModal()">Change Image</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <div>
                <button type="button"
                        class="btn btn-primary ui-profile-save-btn"
                        (click)="onSubmit()"
                        [disabled]="!actionButtonsEnabled()">Save</button>
            </div>
        </form>
    </div>
</section>
